'use strict';

import {Component, Inject, OnInit} from 'ng-metadata/core';
import {PrimolyticsService} from '../../analytics/primolytics.service';
import {getChosenKeepMeSignInConf, getSessionTimeoutParams} from '../../appConfig/appConfigForward';
import {SharedSessionStorage} from "../../infra/sharedSessionStorage.service";
import {UserSessionManagerService} from "../userSessionManager.service";

@Component({
    selector: 'prm-popup-message',
    templateUrl: 'components/security/popupMessage/popup-message.html',
})


export class PrmPopupMessage implements OnInit {

    private chosenConf = getChosenKeepMeSignInConf();
    private MAX_TIMEOUT_SESSION: number = 604800; // 7 days in seconds = 604800

    constructor(@Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('SessionTimeoutService') private sessionTimeoutService,
                @Inject('$element') private $element: ng.IRootElementService,
                private primolyticsService: PrimolyticsService,
                private sharedSessionStorage: SharedSessionStorage,
                private userSessionManagerService: UserSessionManagerService) {
    }

    // 'Yes, keep me signed in' button pressed
    public confirmPopupMessage() {
        this.hidePopupMessage();
        this.sendBriefBeacon('extendSession');

        if (this.chosenConf == 'extend_max') { // Extend the session for predefined maximum period of time
            this.sessionTimeoutService.updateSessionTimeoutTime(this.MAX_TIMEOUT_SESSION);
        } else {                               // Extend the session for another (same) session period
            let sessionTimeoutParams = getSessionTimeoutParams();
            let sessionTimeoutInSeconds = sessionTimeoutParams.userSessionTimeout * 60;
            this.sessionTimeoutService.updateSessionTimeoutTime(sessionTimeoutInSeconds);
        }
    }

    // 'No, sign me out' button pressed
    public closePopupMessage() {
        this.sharedSessionStorage.setItem('showDismissAlert', 'true');
        this.hidePopupMessage();
        this.userSessionManagerService.logout(true);
    }

    private hidePopupMessage() {
        let dialog = this.$element[0].querySelector('#popupDialog') as HTMLDialogElement;
        dialog.close();
    }

    // To keep focus inside the Dialog
    public keyDownSupportGoToFirstButton(e) {
        let sendBtn = document.getElementById('popupMessageConfirmBtn');
        if (sendBtn && e.keyCode === 9) {
            e.preventDefault();
            sendBtn.focus();
        }
    }

    public sendBriefBeacon(currOp) {
        this.primolyticsService.doBeaconReport({
            'p': 'general',
            'op': currOp
        }, this.item, this.primolyticsService.getTimestamp());
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/popupMessage/popupMessage.directive.ts